import React from "react";
import { StatusBar, StyleSheet, View } from "react-native";
import { connect } from "react-redux";
import { STYLES } from "../assets/styles";
import AuthContainer from "./AuthContainer";

function Container({ children, secure = false, loginData = {} }) {
  return (
    <View style={styles.container}>
      {secure && loginData.is_guest ? <AuthContainer /> : children}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: StatusBar.currentHeight,
    backgroundColor: STYLES.colors.white,
  },
});

const mapStateToProps = (state) => ({
  loginData: state.user.loginData,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
